/* eslint-disable no-undef */
import { useSelector, connect } from 'react-redux';
import React, { useState, useEffect, useContext } from 'react';

import Loading from '../../components/common/Loading';
import { convertJspJSONToJSON } from '../../util/formatStrings';

import { initVisibility, updateVisibility } from 'actions/visibilityActions';
import CustomAlert from 'components/common/CustomAlert';
import LocaleContext from 'constants/localization';

const className = 'fields-list';

const FieldVisibilityView = ({ fieldsInput, typesInput, visibilityInput, updateVisibility, initVisibility }) => {

  const [type, setType] = useState(null);
  const [pickedField, setPickedField] = useState(null);
  const [visibility, setVisibility] = useState([]);
  const [changedFields, setChangedFields] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [types, setTypes] = useState([]);

  const LS = useContext(LocaleContext);
  const loading = useSelector(state => state.object.loading);
  const visibilityArray = useSelector(state => state.visibility.visibility);

  //fetches options types and fields
  //updates components visibility state
  //sets global visibility state(it should fetched from sense in the future)
  useEffect(() => {
    const visibilityJson = convertJspJSONToJSON(visibilityInput);
    const menuJson = convertJspJSONToJSON(fieldsInput);
    const typesJson = convertJspJSONToJSON(typesInput);

    setTypes(typesJson.map(t => ({uri: t.uri, label: LS.view[t.label] })).sort((t1, t2) => t1.label.localeCompare(t2.label)));
    setMenuData(Object.entries(menuJson).map(object => ({type: object[0], fields: object[1]})));

    if (visibility.length === 0 ) {
      setVisibility(visibilityJson);
      initVisibility(visibilityJson);
    }
  }, []);

  useEffect(() => {
    if (changedFields && changedFields.length > 0) {
      MetadataView.getMenuInputChanges = () => true;
    } else {
      MetadataView.getMenuInputChanges = () => false;
    }
  }, [changedFields]);

  //updates local state of visibility. Needed to avoid infinite loop
  useEffect(() => {
    if (visibilityArray) {
      setVisibility(visibilityArray);
    } 
  }, [visibilityArray, changedFields]);

  if (!alert) {
    setAlert({showing: false});
  }

  if (loading || menuData.length === 0 || visibility.length === 0 || !alert) {
    return <Loading />;
  }

  var currentTypeObject = menuData.filter(object => object.type === (type ? type.type : types[0].uri));

  if (currentTypeObject.length === 0) {
    currentTypeObject = menuData.slice(0, 1);
  }

  if (!type) {
    setType(currentTypeObject[0]);
  }

  const currentType = currentTypeObject[0].type;
  const currentFields = currentTypeObject[0].fields;

  return (
    <div className={className} style={fieldVisibilityContainerStyle}>
      <TypeMenu menuData={menuData} types={types} type={type ? type.type : null} setType={setType} pickedField={pickedField} 
        setPickedField={setPickedField} changedFields={changedFields} setChangedFields={setChangedFields} 
        message={LS.fieldVisibility.confirmChangingType} label={LS.fieldVisibility.type} className={className + '_TypeMenu'} />
      <FieldsMenu type={type ? type.type : null} fields={currentFields} setPickedField={setPickedField} 
        changedFields={changedFields} visibility={visibility} className={className + '_FieldsMenu'} label={LS.fieldVisibility.field} />
      <div>
        <Button text={LS.fieldVisibility.changeVisibility} handleClick={() => 
          changeVisibility(currentType, pickedField, changedFields, setChangedFields, visibility, setAlert, LS.fieldVisibility.noFieldChosen)} />
        <Button text={LS.fieldVisibility.saveVisibility} handleClick={() => 
          saveVisibility(changedFields, setChangedFields, updateVisibility, saveVisibility)}
        disabled={!(changedFields && changedFields.length > 0)} id='save-visibility'/>
      </div>
      <CustomAlert alert={alert} onClose={() => setAlert(null)} />
    </div>
  );
};

const changeVisibility = (currentType, pickedField, changedFields, setChangedFields, visibility, setAlert, alertText) => {
  if (!pickedField) {
    const alert = {showing: true, timeOut: '5000', contents: alertText};
    setAlert(alert);
    return null;
  }

  const containsElement = changedFields.find(object => object.type === currentType && object.field === pickedField);

  if (!containsElement) {
    const fieldVisibility = visibility.find(object => object.field === pickedField && object.type === currentType).visibility;
    const newChange = ({ type: currentType, field: pickedField, visibility: !fieldVisibility });
    setChangedFields( [ ...changedFields, newChange]);
  } else {
    const removedArray = changedFields.filter(object => object !== containsElement);
    setChangedFields(removedArray);
  }
};

const saveVisibility = (changedFields, setChangedFields, updateVisibility) => {
  if (changedFields.length === 0) {
    return;
  }
  updateVisibility(changedFields);
  setChangedFields([]);
};

const FieldsMenu = ({ type, fields, setPickedField, changedFields, visibility, className, label }) => {
  return (
    <div style={menuStyle} className={className}>
      {label}:
      <Fields type={type} fields={fields} setPickedField={setPickedField} changedFields={changedFields} visibility={visibility} className={className + '_Fields'} />
    </div>
  );
};

const TypeMenu = ({ menuData, types, type, setType, pickedField, setPickedField, changedFields, setChangedFields, message, className, label }) => {
  return (
    <div style={menuStyle} className={className}>
      {label}:
      <TypeMenuSelect menuData={menuData} types={types} type={type} setType={setType} pickedField={pickedField}
        setPickedField={setPickedField} changedFields={changedFields} setChangedFields={setChangedFields} message={message}/>
    </div>
  );
};

const TypeMenuSelect = ({menuData, types, type, setType, pickedField, setPickedField, changedFields, setChangedFields, message}) => {
  return (
    <select id='type-select' onChange={(event) => {
      let canChangeType = true;
      if (changedFields.length > 0) {
        if (!confirm(message)) {
          canChangeType = false;
        }
      } 
      if (canChangeType) {
        const newType = menuData.filter(type => type.type === types.filter(t => t.label === event.target.value)[0].uri)[0];
        setType(newType);
        setChangedFields([]);
        if (type && !isSameFieldForChangedType(type, newType.type, menuData, pickedField)) {
          setPickedField(null);
        }
      } else {
        let currentTypeLabel =  types.filter(t => t.uri === type.type)[0].label;
        $('#type-select').val(currentTypeLabel);
      }
    }} style={objectTypesStyle}>
      {types.map((type, index) =>
        <option key={index}>{type.label}</option>)
      }
    </select>
  )
}

const isSameFieldForChangedType = (oldType, newType, menuData, pickedField) => {
  const oldUriArray = menuData.filter(t => t.type === oldType)[0].fields.map(f => f.uri);
  const newUriArray = menuData.filter(t => t.type === newType)[0].fields.map(f => f.uri);
  return newUriArray.indexOf(pickedField) === oldUriArray.indexOf(pickedField);
};

const Button = ({ text, handleClick, disabled, id }) => {
  return (
    <button onClick={handleClick} 
      type="button"
      className="action-button"
      disabled={disabled || false}
      id={id}>
      {text}
    </button>
  );
};

const menuStyle = { bmargin: '15px'};
const objectTypesStyle = { display: 'inline-block', float: 'left', paddingLeft: '4px', textAlign: 'left', height: '5px'};
const optionStyle = { display: 'inline-block', float: 'left', marginBottom: '20px', marginTop: '5px' };
const fieldVisibilityContainerStyle = { width: '60%', flexDirection: 'row', display: 'left', margin: '10px', align: 'center' };

const optionFormat = (label, uri) => {
  const modUri = uri.substring(uri.lastIndexOf('/') + 1);
  return `${label} (${modUri})`;
};

const fieldStyle = (type, field, changedFields, visibility) => {
  
  var currentlyModified = false;
  if(changedFields.some(object => object.type === type && object.field === field)) {
    currentlyModified = true;
  }

  if (visibility.some(object => object.visibility === false && object.field === field && object.type === type)) {
    return currentlyModified ? { 'color': 'red', 'background': 'gray'} : { 'color': 'red'}; 
  }
  return currentlyModified ? { 'color': 'black', 'background': 'gray'} : { 'color': 'black'}; 
};

const Fields = ({ type, fields, setPickedField, changedFields, visibility, className }) => {
  const optionSize = Math.min(10, fields.filter(f => f.isMandatory === false).length);
  return (
    <div>
      <select onChange={(event) => setPickedField(fields.filter(field => optionFormat(field.label, field.uri) === event.target.value)[0].uri)} 
        style={optionStyle} className={className} size={optionSize}>
        {fields
          .filter(object => object.isMandatory === false)
          .map(object => {
            return <option key={object.uri} style={fieldStyle(type, object.uri, changedFields, visibility)}>{optionFormat(object.label, object.uri)}</option>;
          })
        }
      </select>
    </div>
  );
};

export default connect(null, { saveVisibility, updateVisibility, initVisibility })(FieldVisibilityView);
